import React, { useState, useEffect } from "react";

import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { toast, Bounce } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { apiRequest } from "../../utils/utils";

const RestoreAccount = ({ data, syncFilterWithAggrid, show, close }) => {
  console.log(data, 34353565423423);
  const [newFreeTrialDate, setNewFreeTrialDate] = useState(null);

  useEffect(() => {
    if (data && data.canceled_date) {
      setNewFreeTrialDate(new Date(data.canceled_date * 1000));
    }
  }, [data]);

  //form validation with data set
  const handleNewFreeTrailDateChange = (date) => {
    const newdate = new Date(date);
    const day = String(newdate.getDate()).padStart(2, "0");
    const month = String(newdate.getMonth() + 1).padStart(2, "0");
    const year = newdate.getFullYear();

    const formattedDate = `${month}-${day}-${year}`;

    setNewFreeTrialDate(new Date(newdate));
    //new Date("2024-04-25").getTime()
  };

  // Function to handle data submission
  const handleSubmit = async () => {
    // Submit form data

    const postData = {
      studio_id: data && data.customer_id,
      startDate: newFreeTrialDate,
    };

    let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/restore";
    let responseData;
    try {
      responseData = await apiRequest(crmStagingUrl, "POST", postData);
      //console.log("Response:", responseData);
    } catch (error) {
      console.error("Error:", error);
    }
    if (responseData && responseData.status == "OK") {
      syncFilterWithAggrid();
      // Reset form
      setNewFreeTrialDate(new Date());
      close();
      toast.success(responseData.msg, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } else {
      const errorMessage =
        responseData && responseData.msg
          ? responseData.msg
          : "An error occurred";

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      console.warn("Something went wrong .in change to muvi ownership");
    }

    // Close the modal
  };

  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div class="form-group">
            <label for="recipient-name" className="control-label">
              Company
            </label>
            <input
              type="text"
              className="form-control"
              disabled
              value={data && data.company_name}
            />
          </div>
          <div class="form-group">
            <label for="recipient-name" className="control-label">
              Trial Period
            </label>
            <DatePicker
              selected={newFreeTrialDate}
              dateFormat="dd-MM-yyyy" // You can set the date format here
              placeholderText="Select date"
              onChange={handleNewFreeTrailDateChange}
              //minDate={new Date()}
              yearDropdownItemNumber={15}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={close}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RestoreAccount;



// WEBPACK FOOTER //
// ./src/components/childcomponents/RestoreAccount.js